//import { CartItem } from '@/model/cart.interface';
import { navigateWindow } from '@/router/routerUtils';
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import CartPreviewActions from './CartPreviewActions.vue';
import CartPreviewItem from './CartPreviewItem.vue';
export default Vue.extend({
    components: { CartPreviewItem, CartPreviewActions },
    computed: {
        ...mapGetters('cartModule', ['cartItemsNumber', 'cartItemsPrice']),
        ...mapState('cartModule', ['items']),
        ...mapState('cartModule', ['productPromoCodes']),
        ...mapState('checkoutModule', [
            'appliedPromoCode',
            'appliedOrderPromoCode',
            'selectedShippingMethod',
            'discountState',
            'discountErrorMsg',
            'discountRewardPoints',
            'isCustomerSubscribed',
            'signInToNewsletter',
            'subscriptionAmount',
            'orderDiscountAmount',
            'totalOrderDiscountAmount',
            'isApplyPromoCodeLoading',
            'promoCodes',
            'applyPromoCodeErrorMsg',
        ]),
    },
    props: {
        hideTrigger: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        applyPromoCodeErrorMsg: {
            handler(newError) {
                if (newError) {
                    this.$bvToast.toast(newError, { variant: 'danger', autoHideDelay: 1000, });
                    this.$store.commit('checkoutModule/setApplyPromoCodeErrorMsg', null);
                }
            },
            immediate: true,
            deep: false
        }
    },
    data() {
        return {
            isOpen: false,
            lastFocusedEl: null,
        };
    },
    async created() {
        // if(this.items.length > 0){
        //   await this.getAvailablePromoCodes();
        //   await this.cleanAppliedProductPromoCodes();
        //   await this.callApplyOrderPromoCode({
        //     code: this.appliedOrderPromoCode,
        //     showLoading: false
        //   });
        // }
    },
    mounted() {
        // close on outside click is now handled by overlay; keep global Esc
        document.addEventListener('keydown', this.onKeydown);
        // --- dvh fallback: set and keep --cp-vh in sync with visible viewport
        this.setViewportVar();
        window.addEventListener('resize', this.setViewportVar, { passive: true });
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', this.setViewportVar, { passive: true });
            window.visualViewport.addEventListener('scroll', this.setViewportVar, { passive: true });
        }
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.onKeydown);
        this.unlockScroll();
        window.removeEventListener('resize', this.setViewportVar);
        if (window.visualViewport) {
            window.visualViewport.removeEventListener('resize', this.setViewportVar);
            window.visualViewport.removeEventListener('scroll', this.setViewportVar);
        }
    },
    methods: {
        ...mapActions('checkoutModule', ['applyPromoCode', 'applayedRewardPoints', 'callApplyOrderPromoCode', 'getAvailablePromoCodes']),
        openOrderPromoModal() {
            this.$bvModal.show('orderPromoPreviewModal');
        },
        checkIfAppliedPromoCode() {
            const exists = this.productPromoCodes.some(p => (p.discountAmount > 0));
            if (exists) {
                return true;
            }
            return false;
        },
        checkIfAnyOrderCodeAvailable() {
            return this.promoCodes.some(code => code.is_order_level == 1);
        },
        async cleanAppliedProductPromoCodes() {
            const allowedUuids = new Set(this.items.map(i => i.selectedUnitUuid));
            let newProductPromoCodes = this.productPromoCodes.filter(p => allowedUuids.has(p.productUnitUuid));
            this.$store.commit('cartModule/setProductPromoCodes', newProductPromoCodes);
        },
        async removeOrderPromoCode() {
            this.$store.commit('checkoutModule/setAppliedOrderPromoCode', null);
            this.$store.commit('checkoutModule/setOrderDiscountAmount', 0);
            this.$store.commit('checkoutModule/setTotalOrderDiscountAmount', 0);
            this.callApplyOrderPromoCode();
        },
        async redeemOrderPromoCode(code) {
            this.callApplyOrderPromoCode(code);
        },
        nl2br(val) {
            if (val == null)
                return '';
            return String(val).replace(/\r\n|\n/g, '<br>');
        },
        goToCart() { navigateWindow('cart'); },
        goToCheckout() { navigateWindow('checkout'); },
        toggle(next) {
            const target = typeof next === 'boolean' ? next : !this.isOpen;
            if (target === this.isOpen)
                return;
            this.isOpen = target;
            if (this.isOpen) {
                // remember focus origin, lock scroll, focus drawer
                this.lastFocusedEl = document.activeElement || null;
                this.lockScroll();
                this.$nextTick(() => {
                    const el = this.$refs.drawer;
                    if (el)
                        el.focus({ preventScroll: true });
                });
            }
            else {
                this.unlockScroll();
                if (this.lastFocusedEl)
                    this.lastFocusedEl.focus({ preventScroll: true });
            }
        },
        onKeydown(e) {
            if (e.key === 'Escape' && this.isOpen)
                this.toggle(false);
        },
        lockScroll() {
            // simple body scroll lock
            const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = scrollBarWidth ? `${scrollBarWidth}px` : '';
            document.documentElement.classList.add('cart-open');
        },
        unlockScroll() {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
            document.documentElement.classList.remove('cart-open');
        },
        // --- keeps --cp-vh matching the visible viewport height (excludes browser toolbars)
        setViewportVar() {
            const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
            document.documentElement.style.setProperty('--cp-vh', `${vh * 0.01}px`);
        },
    },
});
